/* @flow */
import * as React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import styles from './styles.module.scss';
import SearchBar from './SearchBar';
import logoImg from '../../assets/images/logo.svg';
import searchRedImg from '../../assets/images/searchRed.svg';
import Icon from '../../components/Icon';
import MenuPopover from '../../components/MenuPopover';
import Modal from '../../components/Modal';
import Toolbar from '../../components/Toolbar';
import OnDemandRequestsForm, { requestTypes } from '../../forms/OnDemandRequestsForm';
import actions from '../../redux/actions';
import { getSearchParams } from '../../redux/reducers/app';
import {
  getMediaSearchLenght as getMediaSearchLength,
  getMediaSearchParams,
} from '../../redux/reducers/mediaSearch';
import {
  getCategoryIsSelected,
  getTrackSearchLength,
  getTrackSearchParams,
} from '../../redux/reducers/trackSearch';
import { getNumberOfItemsInCart } from '../../redux/reducers/cart';
import { getSelectedProductionId } from '../../redux/reducers/productions';
import { getSelectedUsageId, getSessionUsageId, getUsages } from '../../redux/reducers/usages';
import { getWorklist1, getWorklist2 } from '../../redux/reducers/worklists';
import protonesUtils from '../../utils/protones';
import keys from 'config/keys';

import type {
  Translate,
  ReduxState,
  ReactRouterProps,
  Worklist,
  OnDemand,
  SearchParams,
  MediaSearchParams,
  TrackSearchParams,
} from '../../types';
import { withKeycloak } from '@react-keycloak/web';
import { Tooltip } from '@material-ui/core';

const helpFormInitialValues = { id: 0, date: Date.now(), requestType: requestTypes.help };

const mapStateToProps = (state: ReduxState, ownProps) => {
  const usages = _.get(getUsages(state), 'data', []);
  const sessionUsageId = _.get(getSessionUsageId(state), 'data');
  const sessionUsage = usages.find(_ => _.id === sessionUsageId);
  return {
    ...ownProps,
    selectedUsageId: getSelectedUsageId(state),
    sessionUsageName: sessionUsage ? sessionUsage.name : 'Nessuno',
    selectedProductionId: getSelectedProductionId(state),
    numberOfItemsInCart: getNumberOfItemsInCart(state),
    worklist1: getWorklist1(state).data,
    worklist2: getWorklist2(state).data,
    searchParams: getSearchParams(state),
    mediaSearchParams: getMediaSearchParams(state),
    mediaSearchLength: getMediaSearchLength(state),
    trackSearchParams: getTrackSearchParams(state),
    trackSearchLength: getTrackSearchLength(state),
    categoryIsSelected: getCategoryIsSelected(state),
  };
};

type Props = ReactRouterProps & {
  keycloak: Keycloak,
  className?: string,
  selectedProductionId?: ?number,
  selectedUsageId?: ?number,
  sessionUsageName: string,
  selectedWorklistId?: ?number,
  numberOfItemsInCart: number,
  worklist1: Worklist,
  worklist2: Worklist,
  searchParams: SearchParams,
  mediaSearchParams: MediaSearchParams,
  trackSearchParams: TrackSearchParams,
  mediaSearchLength: number,
  trackSearchLength: number,
  categoryIsSelected: boolean[],
  performMediaSearch: typeof actions.performMediaSearch,
  performTrackSearch: typeof actions.performTrackSearch,
  submitOnDemandRequest: typeof actions.submitOnDemandRequest,
  t: Translate,
  location: any,
};

type menuPopoverItem = { text: string, onClick: () => any, iconName: string };

type menuPopoverGroup = 'REPORT' | 'PROFILE' | 'INFO';

type State = {
  isMenuPopoverVisible: boolean,
  menuPopoverGroup: menuPopoverGroup,
  isAskHelopModalVisible: boolean,
};

class Header extends React.PureComponent<Props, State> {
  playerRef: any = null;
  state = {
    isMenuPopoverVisible: false,
    menuPopoverGroup: 'INFO',
    isAskHelopModalVisible: false,
    activeLink: '',
  };

  _toggleReportVisibility = () => {
    const { isMenuPopoverVisible, menuPopoverGroup } = this.state;
    if (menuPopoverGroup !== 'REPORT' && isMenuPopoverVisible) {
      this.setState({ menuPopoverGroup: 'REPORT' });
    } else {
      this.setState({ menuPopoverGroup: 'REPORT', isMenuPopoverVisible: !isMenuPopoverVisible });
    }
  };

  _toggleProfileVisibility = () => {
    const { isMenuPopoverVisible, menuPopoverGroup } = this.state;
    if (menuPopoverGroup !== 'PROFILE' && isMenuPopoverVisible) {
      this.setState({ menuPopoverGroup: 'PROFILE' });
    } else {
      this.setState({ menuPopoverGroup: 'PROFILE', isMenuPopoverVisible: !isMenuPopoverVisible });
    }
  };

  _toggleInfoVisibility = () => {
    const { isMenuPopoverVisible, menuPopoverGroup } = this.state;
    if (menuPopoverGroup !== 'INFO' && isMenuPopoverVisible) {
      this.setState({ menuPopoverGroup: 'INFO' });
    } else {
      this.setState({ menuPopoverGroup: 'INFO', isMenuPopoverVisible: !isMenuPopoverVisible });
    }
  };

  _getSearchPlaceholder = () => {
    const { t } = this.props;
    switch (this.props.location.pathname) {
      case '/medias/search':
        return t('SEARCH_SUPPORTS');
      case '/tracks/search':
      default:
        return t('SEARCH_TRACKS');
    }
  };

  _handleSearchSubmit = (params: SearchParams) => {
    const {
      // searchParams,
      // mediaSearchParams,
      performMediaSearch,
      // trackSearchParams,
      performTrackSearch,
    } = this.props;
    performMediaSearch(_.merge({ categoryIds: [] }, params));
    performTrackSearch(_.merge({}, params));
    switch (this.props.location.pathname) {
      case '/medias/search': {
        return;
      }
      case '/tracks/search': {
        return;
      }
      default: {
        protonesUtils.goTo(this.props, protonesUtils.routes.tracks.find());
      }
    }
  };

  _handleWorklistClick = () => {
    let destination;
    if (this.props.selectedWorklistId === undefined) {
      destination = protonesUtils.routes.worklists.find();
    } else if (this.props.selectedWorklistId === null) {
      destination = protonesUtils.routes.worklists.create();
    } else {
      destination = protonesUtils.routes.worklists.get(this.props.selectedWorklistId);
    }
    protonesUtils.goTo(this.props, destination);
  };

  _handleWorklist1Click = event => {
    event.stopPropagation();
    const id = this.props.worklist1 && this.props.worklist1.id;
    if (typeof id === 'number') {
      const destination = protonesUtils.routes.worklists.get(id);
      protonesUtils.goTo(this.props, destination);
    } else {
      this._handleWorklistClick();
    }
  };

  _handleWorklist2Click = event => {
    event.stopPropagation();
    const id = this.props.worklist2 && this.props.worklist2.id;
    if (typeof id === 'number') {
      const destination = protonesUtils.routes.worklists.get(id);
      protonesUtils.goTo(this.props, destination);
    } else {
      this._handleWorklistClick();
    }
  };

  _handleUsageClick = () => {
    let destination;
    if (this.props.selectedUsageId === undefined) {
      destination = protonesUtils.routes.usages.find();
    } else if (this.props.selectedUsageId === null) {
      destination = protonesUtils.routes.usages.create();
    } else {
      destination = protonesUtils.routes.usages.get(this.props.selectedUsageId);
    }
    protonesUtils.goTo(this.props, destination);
  };

  _handleProductionClick = () => {
    let destination;
    if (this.props.selectedProductionId === undefined) {
      destination = protonesUtils.routes.productions.find();
    } else if (this.props.selectedProductionId === null) {
      destination = protonesUtils.routes.productions.create();
    } else {
      destination = protonesUtils.routes.productions.get(this.props.selectedProductionId);
    }
    protonesUtils.goTo(this.props, destination);
  };

  _handleCartClick = () => {
    protonesUtils.goTo(this.props, protonesUtils.routes.cart.items.find());
  };

  _handleAskHelpSubmit = async (request: OnDemand) => {
    await this.props.submitOnDemandRequest(request);
    this.setState({ isAskHelopModalVisible: false });
  };

  render() {
    const {
      className,
      location,
      t,
      keycloak,
      trackSearchLength,
      mediaSearchLength,
      categoryIsSelected,
    } = this.props;
    const { isMenuPopoverVisible, menuPopoverGroup, isAskHelopModalVisible } = this.state;

    const links = [
      {
        to: '/news',
        label: t('NEWS'),
        icon: 'news',
        isActive: (match, location) => location.pathname.startsWith('/news'),
      },
      {
        to: '/featured',
        label: t('FEATURED'),
        icon: 'store',
        isActive: (match, location) => location.pathname.startsWith('/featured'),
      },
      {
        to: '/worklists',
        label: t('WORKLIST'),
        icon: 'worklist',
        isActive: (match, location) => location.pathname.startsWith('/worklists'),
      },

      {
        to: '/smartlists',
        label: t('SMARTLISTS'),
        icon: 'smartlist',
        isActive: (match, location) => location.pathname.startsWith('/smartlists'),
      },

      {
        to: '/tracks/search',
        label: t('TRACKS'),
        icon: 'track',
        isActive: (match, location) => location.pathname.startsWith('/tracks'),
        hasSearchLogo: Boolean(trackSearchLength),
      },
      {
        to: '/medias/search',
        label: t('SUPPORTS'),
        icon: 'support',
        isActive: (match, location) => location.pathname.startsWith('/medias'),
        hasSearchLogo: Boolean(mediaSearchLength),
      },
    ];
    const reportItems = [
      {
        text: t('PURCHASE_HISTORY'),
        // $FlowFixMe
        onClick: () => {
          protonesUtils.goTo(this.props, protonesUtils.routes.purchases.find());
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'shopping_cart',
      },
    ];
    const username = keycloak.idTokenParsed['preferred_username'] || keycloak.idTokenParsed.sub;
    const profileItems = [
      // {
      //   text: t('PROFILE_SETTINGS'),
      //   // $FlowFixMe
      //   onClick: () => protonesUtils.goTo(this.props, protonesUtils.routes.profile.find()),
      //   iconName: 'settings',
      // },
      {
        text: username,
        onClick: () => {
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'person',
      },
      {
        text: t('PRICE_LISTS'),
        // $FlowFixMe
        onClick: () => {
          protonesUtils.openInNewTab(this.props, protonesUtils.routes.pricelists.find());
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'list',
      },
      {
        text: t('TUTORIAL'),
        // $FlowFixMe
        onClick: () => {
          protonesUtils.openInNewTab(this.props, protonesUtils.routes.tutorial.find());
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'info',
      },
      {
        text: t('LEGAL_NOTES'),
        // $FlowFixMe
        onClick: () => {
          protonesUtils.openInNewTab(this.props, protonesUtils.routes.legalNotes.find());
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'list',
      },
      {
        text: t('HELP'),
        // $FlowFixMe
        onClick: () => {
          protonesUtils.openInNewTab(this.props, protonesUtils.routes.help.find());
          this.setState({ isAskHelopModalVisible: true });
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'contact_support',
      },
      {
        text: t('LOGOUT'),
        onClick: () => {
          keycloak.logout();
          this.setState({ ...this.state, isMenuPopoverVisible: false });
        },
        iconName: 'logout',
      },
    ];
    // const infoItems = [
    //   {
    //     text: t('PRICE_LISTS'),
    //     // $FlowFixMe
    //     onClick: () =>
    //       protonesUtils.openInNewTab(this.props, protonesUtils.routes.pricelists.find()),
    //     iconName: 'list',
    //   },
    //   {
    //     text: t('TUTORIAL'),
    //     // $FlowFixMe
    //     onClick: () => protonesUtils.openInNewTab(this.props, protonesUtils.routes.tutorial.find()),
    //     iconName: 'info',
    //   },
    //   {
    //     text: t('LEGAL_NOTES'),
    //     // $FlowFixMe
    //     onClick: () =>
    //       protonesUtils.openInNewTab(this.props, protonesUtils.routes.legalNotes.find()),
    //     iconName: 'list',
    //   },
    //   {
    //     text: t('HELP'),
    //     // $FlowFixMe
    //     onClick: () => {
    //       this.setState({ isAskHelopModalVisible: true });
    //     },
    //     iconName: 'contact_support',
    //   },
    // ];

    if (keys.DISPLAY_VERSION) {
      // infoItems.push({
      //   text: `V. ${keys.DISPLAY_VERSION}`,
      //   onClick: () => null,
      // });
    }

    let menuPopoverItems: menuPopoverItem[] = [];
    switch (menuPopoverGroup) {
      case 'REPORT':
        menuPopoverItems = reportItems;
        break;
      case 'PROFILE':
        menuPopoverItems = profileItems;
        break;
      // case 'INFO':
      //   menuPopoverItems = infoItems;
      //   break;
      default:
        menuPopoverItems = [];
    }
    return (
      <div className={classNames(className, styles.header)}>
        <div className={styles.logo}>
          <img src={logoImg} alt="logo" />
        </div>
        <div className={styles.headerContent}>
          <Toolbar>
            <SearchBar
              placeholder={this._getSearchPlaceholder()}
              onSearchSubmit={this._handleSearchSubmit}
            />
            <div className={styles.headerButtons}>
              {/* <div className={styles.worklistButton} onClick={this._handleWorklistClick}>
                <div
                  className={classNames(
                    styles.worklistButtonLeft,
                    location.pathname.startsWith('/worklists') && styles.isActive
                  )}
                >
                  <Icon name={'worklist'} size="default" />
                  {t('WORKLIST')}
                </div>
                <div className={styles.worklistButtonRight}>
                  <div className={styles.worklistDirectButton} onClick={this._handleWorklist1Click}>
                    <Icon name={'worklist_1'} size="default" />
                  </div>
                  <div className={styles.worklistDirectButton} onClick={this._handleWorklist2Click}>
                    <Icon name={'worklist_2'} size="default" />
                  </div>
                </div>
              </div> */}
              <div
                className={classNames(
                  styles.cartButton,
                  styles.worklists_buttons,
                  location.pathname.startsWith('/worklists') && styles.isActive
                )}
              >
                <Tooltip title={t('worklist 1')}>
                  <div style={{ cursor: 'pointer' }} onClick={this._handleWorklist1Click}>
                    <Icon name={'worklist_1'} size="default" />
                  </div>
                </Tooltip>
                <Tooltip title={t('worklist 2')}>
                  <div style={{ cursor: 'pointer' }} onClick={this._handleWorklist2Click}>
                    <Icon name={'worklist_2'} size="default" />
                  </div>
                </Tooltip>
                {/* <span>{t('worklist 1')}</span> */}
              </div>

              <div
                className={classNames(
                  styles.cartButton,
                  location.pathname.startsWith('/cart') && styles.isActive
                )}
                onClick={this._handleCartClick}
              >
                <Tooltip title={t('CART')}>
                  <div>
                    <Icon name={'shopping_cart'} size="default" />
                  </div>
                </Tooltip>
              </div>

              <div
                className={classNames(
                  styles.reportButton,
                  'ignore-react-onclickoutside',
                  location.pathname.startsWith('/purchase') && styles.isActive
                )}
                onClick={this._toggleReportVisibility}
              >
                <Tooltip title={t('REPORT')}>
                  <div>
                    <Icon name={'history'} size="default" />
                  </div>
                </Tooltip>
              </div>

              <div className={styles.menuPopoverContainer}>
                <MenuPopover
                  visible={isMenuPopoverVisible && menuPopoverGroup === 'REPORT'}
                  onClickOutside={() => this.setState({ isMenuPopoverVisible: false })}
                  items={menuPopoverItems}
                />
              </div>

              <div
                className={classNames(styles.profileButton, 'ignore-react-onclickoutside')}
                onClick={this._toggleProfileVisibility}
              >
                <Tooltip title={t('PROFILE')}>
                  <div>
                    <Icon name={'account'} size="large" />
                  </div>
                </Tooltip>
              </div>
              <div className={styles.menuPopoverContainer}>
                <MenuPopover
                  visible={isMenuPopoverVisible && menuPopoverGroup === 'PROFILE'}
                  onClickOutside={() => this.setState({ isMenuPopoverVisible: false })}
                  items={menuPopoverItems}
                />
              </div>
              {/* <div
                className={classNames(styles.infoButton, 'ignore-react-onclickoutside')}
                onClick={this._toggleInfoVisibility}
              >
                <Icon name={'info'} size="default" />
                <span>{t('INFO')}</span>
              </div>
              <div className={styles.menuPopoverContainer}>
                <MenuPopover
                  visible={isMenuPopoverVisible && menuPopoverGroup === 'INFO'}
                  onClickOutside={() => this.setState({ isMenuPopoverVisible: false })}
                  items={menuPopoverItems}
                />
              </div> */}
              {/* <div className={styles.usageButton} onClick={this._handleUsageClick}>
              <Icon name={'worklist'} />
              {t('USAGE')}
            </div>
            <div className={styles.productionsButton} onClick={this._handleProductionClick}>
              <Icon name={'worklist'} />
              {t('PRODUCTIONS')}
            </div> */}
            </div>
          </Toolbar>
          <div className={styles.links}>
            {links.map((link: any, index) => {
              let showWhite = false;
              if (index === 0) showWhite = categoryIsSelected[0];
              else if (index === 4) showWhite = categoryIsSelected[1];
              else if (index === 5) showWhite = categoryIsSelected[2];
              return (
                <>
                  <div key={`toolbar-link-${index}`}>
                    <NavLink
                      className={`${styles.link} ${showWhite ? styles.white : styles.gray}`}
                      activeClassName={`${styles.linkActive}`}
                      to={link.to}
                      isActive={link.isActive}
                    >
                      <div className={styles.link_content}>
                        <Tooltip title={link.label}>
                          <div>
                            <Icon
                              name={link.icon}
                              size={'small'}
                              style={{ paddingLeft: 4, color: 'inherit' }}
                            />
                          </div>
                        </Tooltip>
                        {link.hasSearchLogo && (
                          <img
                            src={searchRedImg}
                            style={{ width: 12, marginBottom: 12 }}
                            alt={'SEARCH'}
                          />
                        )}
                        <span className={styles.linkText}>{link.label}</span>
                      </div>
                    </NavLink>
                  </div>
                  {index === 2 && <div key="width" style={{ width: 80 }} />}
                </>
              );
            })}
            {/* <div
              style={{
                marginLeft: 'auto',
                marginRight: 4,
              }}
            >
              {`${t('SESSION_USAGE')}: ${sessionUsageName}`}
            </div> */}
          </div>
        </div>
        {isAskHelopModalVisible && (
          <Modal
            title={t('HELP')}
            onDismiss={() => {
              this.setState({ isAskHelopModalVisible: false });
            }}
          >
            <OnDemandRequestsForm
              initialValues={helpFormInitialValues}
              onSubmit={this._handleAskHelpSubmit}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export default withKeycloak(
  withTranslation()(withRouter(connect(mapStateToProps, actions)(Header)))
);
